export default {
  SET_PAYMENT_SCHEDULE: "SET_PAYMENT_SCHEDULE",
  SET_PENDING_WITHDRAWAL: "SET_PENDING_WITHDRAWAL",
  SET_WITHDRAWALS: "SET_WITHDRAWALS",
  SET_CURRENCY: "SET_CURRENCY",
  SET_OFFER: "SET_OFFER",
  SET_OFFER_UNAVAILABLE: "SET_OFFER_UNAVAILABLE",
  SET_TRANSACTIONS_FILTERS: "SET_TRANSACTIONS_FILTERS",
  SET_TRANSACTIONS_LIST: "SET_TRANSACTIONS_LIST",
  SET_SELECTED_WITHDRAW_METHOD: "SET_SELECTED_WITHDRAW_METHOD",
  SET_WITHDRAWAL_ESTIMATE: "SET_WITHDRAWAL_ESTIMATE",
  // Transaction View State
  SET_CURRENT_TRANSACTION_VIEW_STATE: "SET_CURRENT_TRANSACTION_VIEW_STATE",
  SET_SELECTED_TRANSACTION: "SET_SELECTED_TRANSACTION",
  RESET_TRANSACTION_VIEW: "RESET_TRANSACTION_VIEW",
  // Credit Pull
  INIT_STATE: "INIT_STATE",
  SET_CURRENT_ONBOARDING_STEP: "SET_CURRENT_ONBOARDING_STEP",
  SET_NEXT_ONBOARDING_STEP: "SET_NEXT_ONBOARDING_STEP",
  SET_ONBOARDING_SESSION_ID: "SET_ONBOARDING_SESSION_ID",
  SET_SIGNED_CREDIT_PULL: "SET_SIGNED_CREDIT_PULL",
  // Credit Card
  INIT_SUMMARY: "INIT_SUMMARY",
  SET_CARD_STATUS: "SET_CARD_STATUS",
  SET_CARD_LOST_OR_DAMAGED: "SET_CARD_LOST_OR_DAMAGED",
  SET_WITHDRAWAL_VALIDATION: "SET_WITHDRAWAL_VALIDATION",
  SET_AML_SURVEY_DATA: "SET_AML_SURVEY_DATA",
  SET_CURP_VALIDATION_RESULT: "SET_CURP_VALIDATION_RESULT",
  SET_VALIDATION_SUCCESS: "SET_VALIDATION_SUCCESS",
  SET_WITHDRAWAL_ESTIMATE_FIELDS: "SET_WITHDRAWAL_ESTIMATE_FIELDS",
};
